import { observer } from 'mobx-react-lite'
import { type CollaboratorViewModel } from '@/features/jobs/details/components/CollaboratorsCard/CollaboratorViewModel'
import { CollaboratorItem } from '@/features/jobs/details/components/CollaboratorsCard/CollaboratorItem'

export interface CollaboratorItemContainerProps {
  vm: CollaboratorViewModel
}

export const CollaboratorItemContainer = observer(
  function CollaboratorItemContainer({ vm }: CollaboratorItemContainerProps) {
    return (
      <CollaboratorItem
        displayName={vm.member.displayName}
        email={vm.member.email}
        phone={vm.member.phone}
        team={vm.team ? { name: vm.team.name } : undefined}
        type={vm.type}
        formattedType={vm.formattedType}
        formattedRole={vm.formattedRole}
        userPublicId={vm.member.user.publicId}
        isOnline={vm.member.user.online}
        avatar={{
          avatar: vm.member.avatar,
          avatarFallback: vm.member.avatarFallback,
          displayName: vm.member.displayName,
        }}
        canViewUserDetails={vm.canViewUserDetails}
        canViewCollaboratorInfo={vm.canViewCollaboratorInfo}
        canViewCollaboratorEmail={vm.canViewCollaboratorEmail}
        canViewCollaboratorPhoneNumber={vm.canViewCollaboratorPhoneNumber}
      />
    )
  },
)
